import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { MeResponse } from '@/types/api';

export function useAuth() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: () => apiFetch<MeResponse>('/auth/me.php'),
    retry: false,
    staleTime: 60_000
  });
}
